import { React, createRef } from "react";
import { Component, Fragment } from "react";
import axios from "axios";
import { axiosConfig, ValidateEmail, normalize } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import { addNewSubAgent } from "./../../../config/api_calls";

import $ from "jquery";

import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";

import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Select from "react-select";
import countryList from "react-select-country-list";
import PasswordStrengthBar from 'react-password-strength-bar';

const auth = new HelperClass();

class Addagent extends Component {
  constructor() {
    super();
    this.state = {
      serviceData: [],
      select_service: "",
      errorMessage: "",
      serviceId: "",
      agent_title: "",
      agent_name: "",
      agent_logo: "",
      agent_comp: "",
      agent_email: "",
      agent_city: "",
      agent_state: "",
      agent_zip: "",
      agent_country: "",
      agent_address: "",
      agent_address2: "",
      agent_phone: "",
      agent_password: "",
      c_password: "",
      description: "",
      successMessage: "",
      tableLoader: true,
      domain: "",
      step: 1,
      passwordShown: false,
      confirmPasswordShown: false,
      notifyCheckBox: false,
      account_status: "",
      errorName: "",
      errorStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
    };
    this.phoneInputRef = createRef();
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands"
      );
  }
  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };
  serviceSigning = async (value, tableMeta) => {
    console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {}

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "agent_name") {
      value = value.replace(/[^a-zA-Z\s'.,-]/g, "");
    } else if (name === "agent_title") {
      value = value.replace(/[^a-zA-Z0-9\s\-_.,&()]/g, "");
    } else if (name === "agent_comp") {
      value = value.replace(/[^a-zA-Z0-9\s\-_,&().]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleChangeStep = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
    });
    //await this.sendFileData(event.target.files[0]);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          agent_city: city && city !== "" ? city : "",
          agent_state: state && state !== "" ? state : "",
          agent_zip: zipCode && zipCode !== "" ? zipCode : "",
          agent_country: country && country !== "" ? country : "",
          agent_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          agent_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  formAgentUpdate = async () => {
    let {
      agent_title,
      agent_name,
      agent_email,
      agent_password,
      c_password,
      agent_phone,
      agent_address,
      agent_address2,
      agent_zip,
      agent_country,
      agent_city,
      agent_state,
      agent_comp,
      account_status,
    } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      errorName: "",
      errorStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (this.state.agent_name === "") {
      this.setState({
        errorName: "error",
        errorMessage: "Agent Name is required.",
      });
      is_validated = false;
    } else if (this.state.agent_email === "") {
      this.setState({
        errorName: "",
        errorAgentEmail: "error",
        errorMessage: "Email is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(this.state.agent_email) === false) {
      this.setState({
        errorName: "",
        errorAgentEmail: "error",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.state.agent_comp === "") {
      this.setState({
        errorAgentEmail: "",
        errorAgentCompany: "error",
        errorMessage: "Company is required.",
      });
      is_validated = false;
    } else if (this.state.agent_phone === "") {
      this.setState({
        errorAgentCompany: "",
        errorAgentPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(this.state.agent_phone)) {
      this.setState({
        errorAgentCompany: "",
        errorAgentPhone: "error",
        errorMessage: "Invalid phone format.",
      });
      is_validated = false;
    } else if (this.state.agent_address === "") {
      this.setState({
        errorAgentPhone: "",
        errorAgentAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.agent_country === "") {
      this.setState({
        errorAgentAddress: "",
        errorAgentCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (this.state.agent_city === "") {
      this.setState({
        errorAgentCountry: "",
        errorAgentCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (this.state.agent_zip === "") {
      this.setState({
        errorAgentCity: "",
        errorAgentZip: "error",
        errorMessage: "Zip is required.",
      });
      is_validated = false;
    } else if (this.state.agent_state === "") {
      this.setState({
        errorAgentZip: "",
        errorAgentState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (this.state.agent_password === "") {
      this.setState({
        errorAgentState: "",
        errorAgentPassword: "error",
        errorMessage: "Password is required.",
      });
      is_validated = false;
    } else if (this.state.agent_password !== "") {
      if (this.state.agent_password.length < 8) {
        this.setState({
          errorAgentState: "",
          errorAgentPassword: "error",
          errorMessage: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(agent_password)) {
        this.setState({
          errorAgentState: "",
          errorAgentPassword: "error",
          errorMessage: "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.c_password === "") {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (this.state.c_password.length < 8) {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (
        this.state.agent_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      } else if (this.state.account_status === "") {
        this.setState({
          errorCPassword: "",
          errorStatus: "error",
          errorMessage: "Account Status is required.",
        });
        is_validated = false;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (is_validated) {
      let apiResponce = await addNewSubAgent(
        auth.getAccount(),
        auth.getToken(),
        agent_title,
        agent_name,
        agent_email,
        agent_password,
        agent_phone,
        agent_address,
        agent_address2,
        agent_zip,
        agent_country,
        agent_city,
        agent_state,
        agent_comp,
        account_status,
        this.state.notifyCheckBox.toString()
      );
      console.log("Sub Agent Result:", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        this.setState({
          errorMessage: apiResponce.data.errors
            ? String(apiResponce.data.errors).replace(/,/g, "<br />")
            : "Address validation failed",
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessage: "Sub agent added successfully.",
          tableLoader: false,
        });
        setTimeout(async function () {
          window.location.replace("/agents");
        }, 3000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "Account Already Exists"
      ) {
        this.setState({
          errorMessage:
            "Email already exists. Please try different email address.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  handleChangeCountry = (event) => {
    console.log("event.label: ", event.label);
    const agent_country = event.label;
    this.setState({
      agent_country: agent_country,
    });
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const errorStyle = {
      control: (provided) => ({
        ...provided,
        borderColor: this.state.errorAgentAddress ? "red" : "#d3d3d3",
        height: "57px",
      }),
    };
    return (
      <div className="nk-content " id="Services_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/agents")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Agents
                  </Link>
                  <Typography color="textPrimary" className="">
                    Add New Sub Agent
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="card card-bordered">
                <div className="card-inner">
                  <div class="card-head">
                    <h5 class="card-title">Enter sub agent details below.</h5>
                  </div>
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.errorMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  <form method="post" encType="multipart/form-data">
                    <div className="row g-4">
                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="agent_name"
                          name="agent_name"
                          type="text"
                          label="Agent Name"
                          inputProps={{ maxLength: 100 }}
                          value={this.state.agent_name}
                          onChange={this.handleChange}
                          helperText="Enter the sub agent name. Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorName === "error"}
                        />
                      </div>

                      

                      <div className="form-group col-md-3">
                        <MutextField
                          id="agent_title"
                          name="agent_title"
                          type="text"
                          inputProps={{ maxLength: 30 }}
                          label="Agent Title"
                          value={this.state.agent_title}
                          onChange={this.handleChange}
                          helperText="Enter the title here. Allowed characters: (&nbsp; - &nbsp; _ &nbsp; . &nbsp; &nbsp; , &nbsp; &amp; &nbsp; ( ) )"
                          variant="outlined"
                          fullWidth
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="agent_comp"
                          name="agent_comp"
                          type="text"
                          inputProps={{ maxLength: 30 }}
                          label="Agent Company"
                          value={this.state.agent_comp}
                          onChange={this.handleChange}
                          helperText="Enter the company here. Allowed characters: (&nbsp; _ &nbsp; . &nbsp; - &nbsp; , &nbsp; &amp; &nbsp; ( ) )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentCompany === "error"}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="agent_email"
                          name="agent_email"
                          type="email"
                          label="Email Address"
                          defaultValue={this.state.agent_email}
                          onChange={this.handleChange}
                          helperText="Enter your email address here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentEmail === "error"}
                        />
                      </div>

                      <div className="form-group col-md-6">
                        {/*<PhoneInput
                          style={{ height: "71%" }}
                          required
                          defaultCountry={"us"}
                          error={this.state.errorPhone}
                          inputProps={{
                            name: "agent_phone",
                            id: "agent_phone",
                            maxLength: 20,
                          }}
                          value={this.state.agent_phone}
                          onChange={(value) =>
                            this.handleChange({
                              target: { name: "agent_phone", value },
                            })
                          }
                          helperText="Enter the agent phone number."
                          label="Agent Phone Number"
                          ref={this.phoneInputRef}
                          onFocus={this.handleFocus}
                        />*/}
                        <PhoneInput
                          style={{ height: "71%" }}
                          required
                          defaultCountry={"us"}
                          error={this.state.errorPhone}
                          inputProps={{
                            name: "agent_phone",
                            id: "agent_phone",
                            maxLength: 20,
                            className: this.state.errorAgentPhone
                              ? "error-border"
                              : "default-border",
                          }}
                          dialCodePreviewStyleProps={{
                            className: this.state.errorAgentPhone
                              ? "error-border"
                              : "default-border",
                          }}
                          value={this.state.agent_phone}
                          onChange={(value) =>
                            this.handleChange({
                              target: { name: "agent_phone", value },
                            })
                          }
                          helperText="Enter the agent phone number."
                          label="Agent Phone Number"
                          ref={this.phoneInputRef}
                          onFocus={this.handleFocus}
                        />
                      </div>

                      <div className="col-md-6 mt-3 mt-md-0 googleLocation-autocomplete-wrapper">
                        <div
                          class="nk-block-between-md g-4"
                          style={{
                            position: "absolute",
                            zIndex: 9999,
                            right: "13px",
                            top: "-15px",
                          }}
                        >
                          <div class="nk-block-head-content"></div>
                          <div class="nk-block-head-content">
                            <ul class="nk-block-tools gx-3">
                              <li>
                                <a
                                  onClick={this.handleToggle}
                                  class="text-primary fs-11"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "11px",
                                  }}
                                >
                                  {toggleButtonText}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div>
                          {useGooglePlaces ? (
                            <>
                              <GooglePlacesAutocomplete
                                apiKey={
                                  process.env
                                    .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                }
                                selectProps={{
                                  value: {
                                    label: this.state.agent_address,
                                    value: this.state.agent_address,
                                  },
                                  onChange: this.handleAddressSelect,
                                  placeholder: this.state.agent_address
                                    ? null
                                    : "Enter your address..",
                                  styles: {
                                    ...errorStyle,
                                    input: (provided) => ({
                                      ...provided,
                                      color: "black",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: "9",
                                    }),
                                  },
                                }}
                                id="googleLocation-autocomplete"
                              />
                              <p
                                style={{
                                  fontSize: "0.75rem",
                                  fontWeight: 400,
                                  marginTop: "3px",
                                  color: "#526484",
                                  paddingLeft: "13px",
                                }}
                              >
                                Enter your address here.
                              </p>
                            </>
                          ) : (
                            <MutextField
                              required
                              id="agent_address"
                              name="agent_address"
                              type="text"
                              label="PO Box Address"
                              value={this.state.agent_address}
                              onChange={this.handleChange}
                              helperText="Enter valid PO Box Address. i.e, PO Box Number, City, State Zip Code"
                              variant="outlined"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                                required: false,
                              }}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="agent_address2"
                          name="agent_address2"
                          type="text"
                          label="Address 2"
                          value={this.state.agent_address2}
                          onChange={this.handleChange}
                          helperText="If needed, enter additional address details, such as apartment number, suite, or unit."
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            required: false,
                          }}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="agent_city"
                          name="agent_city"
                          type="text"
                          label="City"
                          value={this.state.agent_city}
                          onChange={this.handleChange}
                          helperText="Enter your city here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentCity === "error"}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="agent_state"
                          name="agent_state"
                          type="text"
                          label="State"
                          value={this.state.agent_state}
                          onChange={this.handleChange}
                          helperText="Enter your state here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentState === "error"}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="agent_zip"
                          name="agent_zip"
                          type="text"
                          label="Zip"
                          value={this.state.agent_zip}
                          onChange={this.handleChange}
                          helperText="Enter your zip here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentZip === "error"}
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <Select
                          className="customStyle-country"
                          options={this.countryOptions}
                          value={{
                            label: this.state.agent_country,
                            value: this.state.agent_country,
                          }}
                          onChange={this.handleChangeCountry}
                          placeholder="Select a country"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: "56px",
                            }),
                          }}
                        />
                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-required">
                          Select country
                        </p>
                      </div>

                      <div
                        className="form-group col-md-6"
                        style={{ position: "relative" }}
                      >
                        <MutextField
                          required
                          id="agent_password"
                          name="agent_password"
                          type={this.state.passwordShown ? "text" : "password"}
                          label="Password"
                          defaultValue={this.state.agent_password}
                          inputProps={{ maxLength: 30 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorAgentPassword === "error"}
                        />
                        <a
                          style={{
                            left: "auto",
                            right: "10px",
                            top: "41px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          tabIndex="-1"
                          onClick={this.togglePassword}
                          className="form-icon form-icon-right passcode-switch"
                          data-target="password"
                        >
                          {this.state.passwordShown ? (
                            <em className="icon ni ni-eye-off"></em>
                          ) : (
                            <em className="icon ni ni-eye"></em>
                          )}
                        </a>
                        <small
                          className="form-text"
                          style={{
                            position: "absolute",
                            top: "69px",
                            color: "#555",
                            fontSize: "0.75rem",
                            fontWeight: "400",
                            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                            maxWidth: "95%"
                          }}
                        >
                          Password must be at least 8 characters, with uppercase, lowercase, number & special character.
                        </small>
                        <div style={{ marginTop: "40px" }}>
                          <PasswordStrengthBar password={this.state.agent_password} />
                        </div>
                      </div>

                      <div
                        className="form-group col-md-6"
                        style={{ position: "relative" }}
                      >
                        <MutextField
                          required
                          id="c_password"
                          name="c_password"
                          type={
                            this.state.confirmPasswordShown
                              ? "text"
                              : "password"
                          }
                          label="Confirm Password"
                          defaultValue={this.state.c_password}
                          inputProps={{ maxLength: 30 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorCPassword === "error"}
                        />
                        <a
                          style={{
                            left: "auto",
                            right: "10px",
                            top: "41px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          tabIndex="-1"
                          onClick={this.toggleConfirmPassword}
                          className="form-icon form-icon-right passcode-switch"
                          data-target="password"
                        >
                          {this.state.confirmPasswordShown ? (
                            <em className="icon ni ni-eye-off"></em>
                          ) : (
                            <em className="icon ni ni-eye"></em>
                          )}
                        </a>
                        <small
                                className="form-text"
                                style={{
                                  position: "absolute",
                                  top: "69px",
                                  left: "26px",
                                  color: "#0000008a",
                                  fontSize: "0.75rem",
                                  fontWeight: "400",
                                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                  maxWidth: "95%"
                                }}
                              >
                                Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password.
                              </small> 
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          id="account_status"
                          name="account_status"
                          select
                          label="Select Account Status"
                          value={this.state.account_status}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          helperText="Select the account status here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorStatus === "error"}
                        >
                          <option key="" value=""></option>
                          <option key="5" value="active">
                            Active
                          </option>
                          <option key="10" value="inactive">
                            Inactive
                          </option>
                        </MutextField>
                      </div>

                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-3"
                        style={{ padding: 0, marginLeft: "3rem" }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck2"
                            checked={this.state.notifyCheckBox}
                            onChange={() => {
                              const isChecked = !this.state.notifyCheckBox;
                              this.setState({ notifyCheckBox: isChecked });
                              console.log(
                                "Notify Checkbox Checked:",
                                isChecked
                              );
                            }}
                          />
                          <label
                            class="custom-control-label"
                            for="customCheck2"
                          >
                            Notify Client
                          </label>
                        </div>
                      </div>

                      <div style={{ clear: "both" }}></div>
                      <hr />
                      <div className="form-group text-right col-md-12">
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled={this.state.disabled}
                          onClick={this.formAgentUpdate}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                  {/*<StepWizard>
                    <Step1
                      handleChange={this.handleChangeStep}
                      values={values}
                    />
                    <Step2
                      handleChange={this.handleChangeStep}
                      values={values}
                    />
                  </StepWizard>*/}

                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Addagent);
